// ステータス関連の定数定義
// 注: すべてのステータス定数は動的データに移行しました
// useReservationStatuses フックと statusMapper ユーティリティを使用してください
//
// 移行ガイド:
// - 車両ステータス: useReservationStatuses() から vehicleStatusList を取得
// - 予約ステータス: useReservationStatuses() から reservationStatusList を取得
// - 位置ステータス: useReservationStatuses() から locationStatusList を取得
// - ID/コード変換: statusMapper の getCodeById(), getIdByCode() を使用



// 貸出・返却リストの既定表示ステータス（code ベース。2026-08-04）
//   予約確定 / 貸出済み / 利用中 / オファー中 / 要連絡・未確定 / 保留中 / リクエスト
// ここに無いもの（キャンセル済み・予約に至らなかった・予約がいっぱい・テスト・
// 不正予約（疑い）・他社振替）は「その日に追う必要がない予約」として既定で除外する。
// daylist のフィルタ初期値（localStorage 未保存時）と /monthly-stats の月間集計で共用する。
export const DEFAULT_VISIBLE_STATUS_CODES = [
  'booked', 'done', 'in_use', 'offer', 'mail_ready', 'pending', 'request',
];

// 「当日貸出」の送信対象ステータス（code ベース。2026-08-06）
//   予約確定 / オファー中 / 要連絡・未確定 / 保留中 / リクエスト
// = まだ出発していない予約。出発処理で 予約確定(booked) → 利用中(in_use) に遷移するため、
//   in_use / done がここに入ることはない。
export const PICKUP_TARGET_STATUS_CODES = [
  'booked', 'offer', 'mail_ready', 'pending', 'request',
];

// 「当日返却」の送信対象ステータス（code ベース。2026-08-06）
//   利用中のみ。返却処理で 利用中(in_use) → 貸出済み(done) に遷移するので、
//   done は「返却済み＝もう案内する必要がない」予約。既定では対象外にする。
export const RETURN_TARGET_STATUS_CODES = [
  'in_use',
];

// 連絡手段の配色設定
export const COMMUNICATION_MEDIA_COLORS = {
  TEL: { bg_color: '#FFD700', text_color: '#000000' }, // 黄色
  LINE: { bg_color: '#06C755', text_color: '#FFFFFF' }, // 緑 (LINEブランドカラー)
  SMS: { bg_color: '#1976D2', text_color: '#FFFFFF' }, // 青 (MUI Primary)
  WhatsApp: { bg_color: '#25D366', text_color: '#000000' }, // 緑 (WhatsAppブランドカラー)
  Instagram: { bg_color: '#C13584', text_color: '#FFFFFF' }, // 赤紫
  default: { bg_color: '#555555', text_color: '#FFFFFF' } // その他（濃いグレー）
} as const;
